<template>
  <div class="about-page">
    <common-header />
    <div class="" style="margin: 20px auto; width: 100%">
      <div class="about-header radius-20" style="margin: 0 auto">
        <el-carousel
          v-if="bannerImages.length"
          class="about-carousel margin-bottom-20"
          height="302px"
          arrow="always"
          :interval="4000"
        >
          <el-carousel-item v-for="(img, idx) in bannerImages" :key="idx">
            <img :src="img" class="about-carousel__img" />
          </el-carousel-item>
        </el-carousel>
        <img
          v-else
          src="@/assets/images/icon15.png"
          class="w-1200 h-302 radius-20 margin-bottom-20"
        />
        <div class="about-content bg-white radius-20 padding-20">
          <div class="text-center padding-30 text-bold text-32">
            {{ info.title }}
          </div>
          <div
            v-if="info?.content"
            class="content-text"
            v-html="info?.content"
          ></div>
          <div v-else class="text-center padding-40">暂无内容</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue";
import { getText } from "@/api/user";

export default {
  name: "About",
  components: {
    CommonHeader,
  },
  data() {
    return {
      info: {},
      loading: false,
      bannerImages: [],
    };
  },
  mounted() {
    this.fetchAboutContent();
  },
  methods: {
    // 获取关于我们的内容
    fetchAboutContent() {
      this.loading = true;
      // type=1 表示关于我们
      getText("1")
        .then((response) => {
          this.loading = false;
          this.info = response.data[0];
          this.bannerImages = this.normalizeImages(response.data[0]?.images);
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error("获取内容失败，请稍后重试");
        });
    },
    // images 可能是数组/JSON字符串/逗号分隔字符串，统一归一为图片 URL 数组
    normalizeImages(images) {
      if (!images) return [];
      if (Array.isArray(images)) {
        return images.filter(Boolean);
      }
      if (typeof images === "string") {
        const raw = images.trim();
        if (!raw) return [];
        if (raw.startsWith("[") && raw.endsWith("]")) {
          try {
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
          } catch (e) {
            return [];
          }
        }
        return raw
          .split(",")
          .map((item) => item.trim())
          .filter(Boolean);
      }
      return [];
    },
  },
};
</script>

<style scoped lang="scss">
.about-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #fff6f8 0%, #f3f7ff 100%);
}

/* 头部区域 */
.about-header {
  max-width: 1200px;
  max-height: 452;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: radial-gradient(
        circle at 20% 30%,
        rgba(255, 255, 255, 0.1) 0%,
        transparent 50%
      ),
      radial-gradient(
        circle at 80% 70%,
        rgba(255, 255, 255, 0.1) 0%,
        transparent 50%
      );
    pointer-events: none;
  }
}

.about-content {
  max-width: 1200px;
  margin: 0 auto;
  min-height: 200px;
}

.about-carousel {
  width: 1200px;
  margin: 0 auto;
  border-radius: 20px;
  overflow: hidden;
}

.about-carousel__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.content-text {
  line-height: 1.8;
  color: #333;
  word-wrap: break-word;
}

::v-deep {
  img {
    max-width: 100%;
    height: auto;
  }

  p {
    margin-bottom: 16px;
  }

  h1,
  h2,
  h3 {
    margin-top: 24px;
    margin-bottom: 16px;
  }
}
</style>
